const FormTitle = (props: { children: React.ReactNode }) => {
  return <h2 className="text-m text-black/80 font-semibold leading-5">{props.children}</h2>;
}

export default FormTitle;